import React from 'react';
import InputTextComp from "@components/UI/InputText/Index.jsx";
import { SaveProcesso } from "@services/Processo/Index.jsx";
import { useForm } from 'react-hook-form';
import ButtonComp from "@components/UI/Button/Index.jsx";
import SweetAlert from "@components/Feedback/SweetAlert/Index.jsx";
import SelectOptionComp from '@components/UI/SelectOption/Index.jsx';

const Filter = ({ onSave }) => {

    const { register, handleSubmit, watch, setValue } = useForm();

    const onSubmit = async (data) => {
        try {
            SweetAlert.loading();

            const payload = {

            };

            const result = await SaveProcesso(payload);

            SweetAlert.success('Consulta Concluída!', 'Os dados foram encontrados com sucesso.');

            onSave({ ...result });

        } catch (error) {

            let errorMessage = 'Ocorreu um problema ao tentar consultar os dados.';


            SweetAlert.errorHTML('Erro ao consultar', errorMessage);
            console.error(error);
        }
    };

    return (
        <form onSubmit={handleSubmit(onSubmit)} className='form'>
            <div className="row py-3">

                <div className="col-5 col-md-5">
                    <SelectOptionComp
                        label="Ano"
                        //options={}
                        value={watch("ano")}
                        onChange={(selected) => setValue("ano", selected)}
                        placeholder={"Selecionar um ano"}
                        hoverMessage="Selecionar um ano"
                    />
                </div>

                <div className='col-8 col-md-8'>

                    <SelectOptionComp
                        label="Unidade"
                        //options={}
                        value={watch("unidade")}
                        onChange={(selected) => setValue("unidade", selected)}
                        placeholder={"Selecionar uma unidade"}
                        hoverMessage="Selecionar uma unidade"
                    />

                    <InputTextComp
                        label="Usuário"
                        name="usuario"
                        {...register("usuario")}
                        placeholder={"Preencher com um usuário"}
                        hoverMessage="Preencher com um usuário"
                        maxLength={255}
                        required={true}
                    />

                    <InputTextComp
                        label="Nº Da Solicitação"
                        name="numSolicitacao"
                        {...register("numSolicitacao")}
                        placeholder={"Preencher com o número da solicitação"}
                        hoverMessage="Preencher com o número da solicitação"
                        maxLength={255}
                        required={true}
                    />

                    <SelectOptionComp
                        label="Data Inicial"
                        //options={}
                        value={watch("dataInicial")}
                        onChange={(selected) => setValue("dataInicial", selected)}
                        placeholder={"Selecionar uma data inicial"}
                        hoverMessage="Selecionar uma data inicial"
                    />

                    <SelectOptionComp
                        label="Data Final"
                        //options={}
                        value={watch("dataFinal")}
                        onChange={(selected) => setValue("dataFinal", selected)}
                        placeholder={"Selecionar uma data final"}
                        hoverMessage="Selecionar uma data final"
                    />

                </div>

                <div className="col-8 col-md-8 d-flex flex-wrap justify-content-end mt-4 px-3">
                    <ButtonComp
                        title="APLICAR FILTRO"
                        type="submit"
                        buttonColor="#2b97be"
                        classnameIcon="fa-solid fa-filter"
                        hoverMessage={"Botão para aplicar o filtro da consulta"}
                    />

                    <ButtonComp
                        title="EXPORTAR"
                        type="submit"
                        buttonColor="#125578"
                        classnameIcon="fa-solid fa-file-export"
                        hoverMessage={"Botão para limpar os campos de filtros preenchidos"}
                    />
                </div>

            </div>
        </form>
    );
};

export default Filter;
